export const DEFAULT_Y = 10;

export const POS_MAP_DERZHATEL_MONITORA = {
    smo: {
        y: 11.11,
        x: -0.3,
        z: 0,
    },
    som: {
        y: 11.27,
        x: -0.297,
        z: 0,
    },
};

export const POS_Y_MAP_MIN_MAX = {
    smo: {
        min: 10.243,
        max: 11.443,
    },
    som: {
        min: 10.25,
        max: 11.3,
    },
};
